import React from "react";
import { useTranslation } from "react-i18next";
import { initials } from "../lawyers/lawyerHelpers";
import "./about.css";

const TESTIMONIALS = [
  { text: "Great service", name: "Ali Hamed", location: "Manouba, TN" },
  { text: "Very good services 👌 👍", name: "Ghaith Laouiti", location: "Tunis, TN" },
  { text: "❤❤", name: "Ahmed Arfaoui", location: "Gabes, TN" },
];

export default function TestimonialsSection() {
  const { t } = useTranslation();
  return (
    <section className="avc-section avc-testimonials">
      <div className="container">
        <div className="avc-section__header">
          <h2 className="avc-section__title">{t("Testimonials")}</h2>
          <p className="avc-section__lead">{t("Checkout_what_people_think_about_Us")}</p>
        </div>
        <div className="avc-testimonials__grid">
          {TESTIMONIALS.map((item) => (
            <figure className="avc-quote" key={item.name}>
              <i className="fas fa-quote-right avc-quote__mark" aria-hidden="true"></i>
              <blockquote className="avc-quote__text" dir="auto">
                {item.text}
              </blockquote>
              <figcaption className="avc-quote__author">
                <span className="avc-quote__avatar" aria-hidden="true">
                  {initials(item.name)}
                </span>
                <span>
                  <strong>{item.name}</strong>
                  <small dir="ltr">{item.location}</small>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
